import React from 'react'
import { Squash as Hamburger } from 'hamburger-react'
import { useDispatch, useSelector } from 'react-redux'
import actions from 'redux/settings/actions'
import { Link } from 'react-router-dom'

const HeaderMobile = () => {
  const dispatch = useDispatch()
  const { isMobileMenuOpen } = useSelector(({ settings }) => settings)

  const handleMenu = () => {
    dispatch({
      type: actions.HANDLE_STATE,
      field: 'isMobileMenuOpen',
      value: !isMobileMenuOpen
    })
  }

  return (
    <div className='mpx-container mpx-header--mobile' >
      <div className='logo'>
        <Link to='/'>
          {/* <img src='/images/logo/logo-mpxgo-main.png' alt='MPX LOGO' /> */}
          <img src='/images/logo/LOGO MLI WEBSITE.png' alt='MPX LOGO' style={{maxWidth: '100%'}} />

        </Link>
      </div>
      <div className='nav-toggle'>
        <Hamburger toggled={isMobileMenuOpen} toggle={handleMenu} />
      </div>
    </div >
  );
}

export default HeaderMobile;